import React from 'react';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Input,
  Tooltip,
  Typography,
} from '@material-ui/core';
import {
  BreadcrumbActiveItemStyle,
  EditedIconStyle,
  DialogStyle,
} from './style';

export const LongLabel = (props: { label: string }) => {
  return props.label.length > 65 ? (
    <Tooltip title={props.label}>
      <div>{props.label.slice(0, 65)}...</div>
    </Tooltip>
  ) : (
    <span
      css={`
        font-weight: 700;
      `}
    >
      {props.label}
    </span>
  );
};

export const EditedTypography = (props: { label: string }) => {
  const [open, setOpen] = React.useState(false);
  const [label, setLabel] = React.useState(props.label);
  const [templabel, setTempLabel] = React.useState(props.label);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleInputChange = (event: any) => {
    setTempLabel(event.target.value);
  };

  const handleSaveClose = () => {
    setLabel(templabel);
    setOpen(false);
  };
  return (
    <Typography key={props.label} css={BreadcrumbActiveItemStyle}>
      <LongLabel label={label} />
      <IconButton css={EditedIconStyle.button} onClick={handleClickOpen}>
        <EditIcon css={EditedIconStyle.icon} />
      </IconButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="dialog-title"
        fullWidth
      >
        <DialogTitle id="dialog-title">
          <Typography css={DialogStyle.title}>Activity Name</Typography>
        </DialogTitle>
        <DialogContent>
          <Input
            autoFocus
            margin="none"
            fullWidth
            css={DialogStyle.input}
            defaultValue={label}
            onChange={handleInputChange}
          />
        </DialogContent>
        <DialogActions css={DialogStyle.action}>
          <Button
            onClick={handleClose}
            css={DialogStyle.button}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveClose}
            css={[DialogStyle.buttonSave, DialogStyle.button]}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Typography>
  );
};
